export const FACILITIES_LOADING = 'FACILITIES_LOADING';
export const FACILITIES_SUCCESS = 'FACILITIES_SUCCESS';
export const FACILITIES_FAILURE = 'FACILITIES_FAILURE';
